// @ts-nocheck
(function () {
  'use strict';

  function boot() {
    var section = document.querySelector('[data-gb-login]');
    if (!section) return;

    var url      = section.dataset.supabaseUrl;
    var key      = section.dataset.anonKey;
    var adminUrl = section.dataset.adminUrl || '/pages/events-admin';

    if (!window.supabase) {
      console.error('Supabase SDK not loaded');
      return;
    }

    var sb = window.supabase.createClient(url, key);

    // If already logged in → go straight to admin
    sb.auth.getSession().then(function (res) {
      if (res.data.session) {
        window.location.replace(adminUrl);
      }
    });

    var form      = section.querySelector('[data-gb-login-form]');
    var errorEl   = section.querySelector('[data-gb-login-error]');
    var errorMsg  = section.querySelector('[data-gb-login-error-msg]');
    var submitBtn = section.querySelector('[data-gb-login-submit]');
    var label     = section.querySelector('[data-gb-login-label]');
    var spinner   = section.querySelector('[data-gb-login-spinner]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      var email    = form.querySelector('#gb-login-email').value.trim();
      var password = form.querySelector('#gb-login-password').value;

      if (!email || !password) {
        showError('Bitte E-Mail und Passwort eingeben.');
        return;
      }

      setLoading(true);

      sb.auth.signInWithPassword({ email: email, password: password })
        .then(function (res) {
          if (res.error) {
            setLoading(false);
            showError('E-Mail oder Passwort ist falsch.');
            return;
          }
          window.location.replace(adminUrl);
        })
        .catch(function () {
          setLoading(false);
          showError('Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.');
        });
    });

    function setLoading(loading) {
      submitBtn.disabled = loading;
      label.hidden       = loading;
      spinner.hidden     = !loading;
    }

    function showError(msg) {
      errorMsg.textContent = msg;
      errorEl.hidden = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
